import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const NavLinks = ({ isSidebarOpen, toggleSidebar, isMobile }) => {
  const { data, loading, error } = useSelector((state) => state.api);
  const [openDropdown, setOpenDropdown] = useState(null);
  const handleMouseEnter = (menu) => setOpenDropdown(menu);
  const handleMouseLeave = () => setOpenDropdown(null);

  const handleMobileLinkClick = () => {
    if (isMobile) {
      toggleSidebar();
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading navigation links</div>;
  const renderHierarchy = (items, level = 0) => {
    if (!items || items.length === 0) return null;

    return items.map((item, index) => (
      <div
        key={`${item.name}-${level}-${index}`}
        className={`mb-2 ${level === 0 ? "border-b border-gray-300 pb-2" : ""}`}
      >
        <Link
          to={
            item.Products?.length > 0
              ? `category/${item.name}`
              : `product/${item.id}`
          }
          className={`text-xs hover:text-gray-600 ${
            item.Products?.length > 0 ? "font-bold" : ""
          }`}

          onClick={handleMobileLinkClick}
        >
          {item.name}
        </Link>
        {item.Products?.length > 0 && (
          <div className="pl-4 mt-1">
            {/* {item.level = level} */}
            {renderHierarchy(item.Products, level + 1)}
          </div>
        )}
      </div>
    ));
  };
  const renderCategories = (categories, imageHeight = 400) => {
    const MAX_COLUMNS = 5;
    const itemsPerColumn = Math.floor(imageHeight / 40); // Approximate height per item is 40px
    const flatItems = [];

    const flattenHierarchy = (items) => {
      items.forEach((item) => {
        flatItems.push(item);
        if (item.Products?.length > 0) {
          flattenHierarchy(item.Products);
        }
      });
    };
    flattenHierarchy(categories);
    const columns = [];
    let currentColumn = [];
    flatItems.forEach((item, index) => {
      currentColumn.push(item);
      if ((index + 1) % itemsPerColumn === 0) {
        columns.push(currentColumn);
        currentColumn = [];
      }
    });
    if (currentColumn.length > 0) {
      columns.push(currentColumn);
    }
    return (
      <div
        className={`grid grid-cols-${Math.min(
          columns.length,
          MAX_COLUMNS
        )} gap-4`}
      >
        {columns.map((column, colIndex) => (
          <div key={colIndex} className="col-span-1">
            {column.map((item, itemIndex) => (
              <div
                key={itemIndex}
                className={`mb-2 ${
                  item.isCategory == true ? "border-b border-gray-300 pb-2" : ""
                }`}
              >
                <Link
                  to={
                    item.Products?.length > 0
                      ? `category/${item.name}`
                      : `product/${item.id}`
                  }
                  className={`text-xs hover:text-gray-600 ${
                    item.Products?.length > 0 ? "font-bold" : ""
                  }`}
                >
                  {item.name}
                </Link>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      {!isMobile ? (
        <div className="flex  space-x-6 pb-2 justify-center items-center bg-white border-t border-gray-200 min-h-[60px]">
          {data?.nav_links?.map((navItem) => (
            <div
              key={navItem.name}
              className="group py-2"
              onMouseEnter={() => handleMouseEnter(navItem.name)}
              onMouseLeave={handleMouseLeave}
              onClick={handleMouseLeave}
            >
              <Link
                to={`collections/${navItem.name}`}
                className="text-[#222222] font-medium hover:text-gray-500"
              >
                {navItem.name}
              </Link>
              {openDropdown === navItem.name && (
                <div
                  className="absolute left-0 mt-2 w-screen px-44 bg-white shadow-lg  p-6 z-50 overflow-y-auto"
                  style={{ maxHeight: "80vh" }}
                >
                  <div className="grid grid-cols-5 gap-2">
                    {navItem.image && (
                      <div className="col-span-1  z-0   ">
                        <Link
                          to={`collections/${navItem.name}`}
                          className="text-gray-800 hover:text-gray-500"
                        >
                          <img
                            src={navItem.image}
                            alt={`${navItem.name} Collection`}
                            className="rounded-lg"
                            onClick={handleMouseLeave}
                          />
                          <div
                            className="flex  justify-center mt-[-48px] relative z-10 text-black"
                            onClick={handleMouseLeave}
                          >
                            <button className="bg-white w-[100px] rounded-[6px] font-montserrat ">
                              View More
                            </button>
                          </div>
                        </Link>
                      </div>
                    )}
                    <div
                      className="col-span-4  ml-2"
                      onClick={handleMouseLeave}
                    >
                      {renderCategories(
                        navItem.Categories,
                        navItem.imageHeight || 400
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        isSidebarOpen && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-start">
            <div
              className="bg-white w-80 h-full overflow-auto"
              style={{ maxHeight: "100vh" }}
            >
              <div className="flex justify-around my-3">
                <Link to="/login" onClick={handleMobileLinkClick}>
                  <div className="flex flex-col items-center p-6 py-3 border border-black rounded-xl">
                    <i className="fa-regular fa-circle-user text-4xl"></i>
                    <p className="text-xs font-medium mt-2">Login</p>
                  </div>
                </Link>
                <Link to="/contact-us" onClick={handleMobileLinkClick}>
                  <div className="flex flex-col items-center p-3 py-3 border border-black rounded-xl">
                    <i className="fa-solid fa-phone text-4xl"></i>
                    <p className="text-xs font-medium mt-2">Contact Us</p>
                  </div>
                </Link>
                <Link to="/store-locator" onClick={handleMobileLinkClick}>
                  <div className="flex flex-col items-center p-6 py-3 border border-black rounded-xl">
                    <i className="fa-solid fa-store text-4xl"></i>
                    <p className="text-xs font-medium mt-2">Stores</p>
                  </div>
                </Link>
              </div>
              <ul>
                {data?.nav_links?.map((navItem) => (
                  <li key={navItem.name}>
                    <div className="flex justify-between items-center px-4 py-2">
                      <Link
                        to={`collections/${navItem.name}`}
                        className="text-gray-800 text-xs font-bold block"
                        onClick={handleMobileLinkClick}
                      >
                        {navItem.name}
                      </Link>
                    </div>
                    <div className="pl-4">
                      {renderHierarchy(navItem.Categories)}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              onClick={toggleSidebar}
              className="text-black mb-4 bg-black p-4 py-2"
            >
              <i className="fa-regular fa-x text-white text-2xl"></i>
            </button>
          </div>
        )
      )}
    </div>
  );
};

export default NavLinks;
